<template>
  <label class="file-select">
    <div class="select-button" v-on:click="geolocate()">
      <span>Your latitude: {{lat}}</span>
      <span>Your longitude: {{lng}}</span>
    </div>
  </label>
</template>

<script>

export default {
  name: "GPS",
  data() {
    return {
      error: "",
      lat: 0,
      lng: 0
    };
  },
  mounted() {
    this.geolocate();
  },

  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }
};
</script> 

<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #2ea169;

  border-radius: 0.3rem;

  text-align: center;
  font-weight: bold;
}

/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>